import { AutogenLayoutPayAdjustmentCode } from "./autogen/AutogenLayoutPayAdjustmentCode";
import {
    ChangeEvent, Checkbox, DataHeader, DataSourceMode, LookupModelSearchEvent, ValidationResult, DataSourceExecutionEvent, DropdownSelectionEvent
} from "@mcleod/components";
import { ConversionUtil, ModelRow } from "@mcleod/core";
import { getPayrollControlBoolean, LMEGeneralSettings } from "@mcleod/general";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "deduct_code",
    screenName: "Pay Adjustment Code",
    navigateToUrl: "lme/settlement/PayAdjustmentCode?mode=update&key="
};

export class PayAdjustmentCode extends AutogenLayoutPayAdjustmentCode {
    async onLoad(): Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.textboxGlid.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            if (mode === DataSourceMode.SEARCH) {
                return null;
            }
            const result: ValidationResult = {
                isValid: true,
                component: this.textboxGlid
            }
            const lookupData: ModelRow = this.textboxGlid.getFirstLookupModelData();
            const isEscrow = lookupData.getBoolean("is_escrow", false);
            if (isEscrow && (this.textboxCodeType.selectedItem.value === "E" || this.textboxCodeType.selectedItem.value === "P")) {
                result.isValid = false;
                result.validationMessage = "Escrow accounts cannot be used with Earning or Per Diem code types.";
            }
            return result;
        };
        const dispatchControl = LMEGeneralSettings.getSingleton().getDispatchControl();
        this.textboxWeightCutoff.visible = this.checkboxOverweightPay.visible = ConversionUtil.parseBoolean(dispatchControl.is_container_active);
        this.checkboxExcludeCommissions.visible = getPayrollControlBoolean("enable_commissions", false);
        this.textboxCodeType.addChangeListener((event: ChangeEvent) => {
            if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
                return;
            }
            this.textboxGlid.validateSimple();
            if (this.checkboxExcludeCommissions.visible) {
                if (this.textboxCodeType.selectedItem.value === "E") {
                    this.checkboxExcludeCommissions.enabled = true;
                }
                else {
                    this.checkboxExcludeCommissions.enabled = false;
                    this.checkboxExcludeCommissions.checked = false;
                }
            }
            switch (this.textboxCodeType.selectedItem.value) {
                case "E": // Earning
                    this.setAllTaxSwitches(true, true);
                    break;
                case "P": // Per Diem
                    this.setAllTaxSwitches(false, false);
                    break;
                case "B": // Before-tax deduction
                    this.setAllTaxSwitches(false, true);
                    break;
                case "D": // After-tax deduction
                    this.setAllTaxSwitches(true, false);
                    break;
                case "R": // Reimbursement
                    this.setAllTaxSwitches(false, false);
                    break;

            }
        });
    }

    setAllTaxSwitches(value: boolean, enabled: boolean = true) {
        this.panelTaxes.findComponentsByType(Checkbox).forEach((cb: Checkbox) => {
            cb.checked = value;
            cb.enabled = enabled
        });
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    textboxGlidBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
    }

    updateCommissionsExclude(){
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH) {
            const isEarningCode = this.activeRow.get("code_type") === "E";
            this.checkboxExcludeCommissions.enabled = isEarningCode;
            if (!isEarningCode) {
                this.checkboxExcludeCommissions.checked = false;
            }
        }
    }

    /** This is an event handler for the afterExecution event of sourceDeductCode. */
    sourceDeductCodeAfterExecution(event: DataSourceExecutionEvent) {
        this.updateCommissionsExclude();
    }

    /** This is an event handler for the afterDropdownSelection event of textboxCodeType. */
    textboxCodeTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.updateCommissionsExclude();
    }
}
